import React, { useState, useEffect } from "react";

import IntelligenceTimeRangeListDropdown from "./intelligenceTimeRangeListDropdown";
import getDates from "./../../../shared/services/date.service";

import styles from "./intelligenceTimeRangeList.module.scss";

// days - how many days ago a time period began
// isFull - true if the time period duration and the date variable are equal, false if the time period lasts one day
const getTimeRangeDates = (days, isFull) => {
  const date = new Date();
  const duration = isFull ? days - 1 : days; // fix the number of days to set the end of the time period to the current date
  const rangeStartDate = new Date(date.getTime() - duration * 24 * 60 * 60 * 1000);
  const startDate = getDates.getNullTimeDate(rangeStartDate);
  const rangeEndDate = new Date();
  const endDate = isFull ? getDates.getEndDayTimeDate(rangeEndDate) : getDates.getEndDayTimeDate(startDate);

  return {
    startDate,
    endDate,
  };
};

const IntelligenceTimeRangeList = (props) => {
  const { onHandleChangeStore } = props;

  const setDates = (days, isFull) => {
    const dates = getTimeRangeDates(days, isFull);

    onHandleChangeStore("rangeStartDate", dates.startDate);
    onHandleChangeStore("rangeStartTime", dates.startDate);
    onHandleChangeStore("rangeEndDate", dates.endDate);
    onHandleChangeStore("rangeEndTime", dates.endDate);
  };

  return (
    <div className={styles.rangeList}>
      <div className={styles.rangeListItem}>
        <span onClick={setDates.bind(this, 0, false)}>Сегодня</span>
      </div>
      <div className={styles.rangeListItem}>
        <span onClick={setDates.bind(this, 1, false)}>Вчера</span>
      </div>
      <div className={styles.rangeListItem}>
        <span onClick={setDates.bind(this, 7, true)}>Последние 7 дней</span>
      </div>
      <div className={styles.rangeListItem}>
        <span onClick={setDates.bind(this, 31, true)}>Текущий месяц</span>
      </div>
      <div className={styles.rangeListItem_dropdown}>
        <IntelligenceTimeRangeListDropdown title="Иные" handleClick={setDates} />
      </div>
    </div>
  );
};

export default React.memo(IntelligenceTimeRangeList);
